import ResetPWBackground from "../components/forgetPassword/ResetPWBackground"

function ResetPassword() {
    return (
        <ResetPWBackground />
    );
}

export default ResetPassword;